module.exports = (parcelRequire.load("hIETI")).then(() => parcelRequire('amr3n'));